"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstDateFromDateRange = void 0;
const dateSelectionTypes_1 = require("../../constants/dateSelectionTypes");
const addBankingDays_1 = require("../addBankingDays");
const addProcessingDays_1 = require("../addProcessingDays");
const addTradingDays_1 = require("../addTradingDays");
const isBankingDay_1 = require("../isBankingDay");
const isProcessingDay_1 = require("../isProcessingDay");
const isTradingDay_1 = require("../isTradingDay");
const moveDateByUnits_1 = require("../../utils/moveDateByUnits");
function getFirstDateFromDateRange(date, dateSelectionType, dateTimeUnit, magnitude) {
    const firstDateForDateRange = (0, moveDateByUnits_1.moveDateByUnits)(date, dateTimeUnit, magnitude)
        .startOf(dateTimeUnit)
        .toFormat('yyyy-MM-dd');
    let firstDateForDateRangeWithDateType;
    if (dateSelectionType === dateSelectionTypes_1.DateSelectionTypes.BANKING && !(0, isBankingDay_1.isBankingDay)(firstDateForDateRange)) {
        firstDateForDateRangeWithDateType = (0, addBankingDays_1.addBankingDays)(firstDateForDateRange, 1);
    }
    else if (dateSelectionType === dateSelectionTypes_1.DateSelectionTypes.PROCESSING && !(0, isProcessingDay_1.isProcessingDay)(firstDateForDateRange)) {
        firstDateForDateRangeWithDateType = (0, addProcessingDays_1.addProcessingDays)(firstDateForDateRange, 1);
    }
    else if (dateSelectionType === dateSelectionTypes_1.DateSelectionTypes.TRADING && !(0, isTradingDay_1.isTradingDay)(firstDateForDateRange)) {
        firstDateForDateRangeWithDateType = (0, addTradingDays_1.addTradingDays)(firstDateForDateRange, 1);
    }
    else {
        firstDateForDateRangeWithDateType = firstDateForDateRange;
    }
    return firstDateForDateRangeWithDateType;
}
exports.getFirstDateFromDateRange = getFirstDateFromDateRange;
//# sourceMappingURL=index.js.map